import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { ChatIcon } from '@change/ds-icons';

import type { QuoteCardData } from '../../hooks/usePetitionMarquee';
import { CardWrapper } from '../CardWrapper';

type Props = Readonly<{
	petition: QuoteCardData;
	onClick: () => void;
	duplicate?: boolean;
}>;

/**
 * Four card types share this layout - a quote with an eyebrow above and a source line below.
 * Only where the text comes from separates them, and the hook resolves that, so this renders
 * the same shape whatever the type.
 */
export const QuoteCard: React.FC<Props> = ({ petition, onClick, duplicate = false }) => (
	<CardWrapper
		cardKey={petition.key}
		href={petition.href}
		onClick={onClick}
		duplicate={duplicate}
		icon={ChatIcon}
		label={petition.label}
		trailingLabel={petition.relativeTimeLabel}
	>
		<Text as="q" variant="body" size="small" className="text-typography-strong line-clamp-3 italic" expressive>
			{petition.quote}
		</Text>
		<Text as="span" variant="body" size="x-small" className="text-typography-weak mt-auto line-clamp-1 pt-2">
			{petition.subLabel}
		</Text>
	</CardWrapper>
);
